 <a (click)="goToHomeLanding()" class="link-secondary mr-3 mr-md-5">{{ 'rememberpasssword.Conócenos' | translate }}</a>
 <a (click)="goToContact()" class="link-secondary mr-3 mr-md-5">{{ 'rememberpasssword.Contacto' | translate }}</a>